import React, { useSyncExternalStore } from 'react';
import { DEFAULT_LANGUAGE, getLanguage, normalizeLanguage, t } from '../i18n';
import { DEFAULT_THEME, getTheme, subscribeToTheme } from '../services/ThemeService';
import logoKoLight from '../assets/branding/logo-ko-light.gif';
import logoKoDark from '../assets/branding/logo-ko-dark.gif';
import logoEnLight from '../assets/branding/logo-en-light.gif';
import logoEnDark from '../assets/branding/logo-en-dark.gif';
import './AppLogo.css';

const logos = {
  ko: { light: logoKoLight, dark: logoKoDark },
  en: { light: logoEnLight, dark: logoEnDark },
};
const getServerTheme = () => DEFAULT_THEME;
const getServerLanguage = () => DEFAULT_LANGUAGE;
const subscribeToLanguage = (listener) => {
  window.addEventListener('appLanguageChanged', listener);
  return () => window.removeEventListener('appLanguageChanged', listener);
};

export default function AppLogo({ className = '', language }) {
  const theme = useSyncExternalStore(subscribeToTheme, getTheme, getServerTheme);
  const appLanguage = useSyncExternalStore(subscribeToLanguage, getLanguage, getServerLanguage);
  const resolvedLanguage = normalizeLanguage(language ?? appLanguage);

  return (
    <img
      className={`app-logo${className ? ` ${className}` : ''}`}
      src={logos[resolvedLanguage][theme]}
      alt={t('app.title.aria', resolvedLanguage)}
      width="288"
      height="72"
    />
  );
}
